import React, { Component } from "react";
import {
  company, // ดึง company context ถ้ามี
  loading,
  NavbarAdmin,
  Pagination,
  alert,
  GET,
  POST,
  PUT,
  DELETE,
  UPLOAD,
  MAX_UPLOAD_SIZE,
  Select,
  Modal,
  toFixed,
  t,
  float,
  format_date,
  DatePicker
} from "../../components/CustomComponent.js";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import PROVINCE from "../../assets/files/th_province.json";
import { data } from "react-router";
import { required } from "../../utils/helpers.js";

export default class AssetManagement extends Component {
  isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
  };

  constructor(props) {
    super(props);
    this.state = {
      // Filters
      filter_search: "",
      filter_customer: "",
      filter_category: "",
      filter_status: "",
      filter_vendor_warranty: "",

      // Data
      data: [],
      data_customer: [],
      data_finance: [],
      data_sale: [],
      data_part: [],
      data_branch: [],
      data_cwc: [],
      count: 0,

      // Modal State
      modal_view: false,
      modal_create: false,
      modal_map: false,
      modal_view_closing: false,
      modal_create_closing: false,

      // --- Form Fields (Mapped to API Payload) ---
      uid: "",
      company_id: company?.id || "446a2297-d012-43a1-af6c-eda4055099cf", // ใส่ default ตาม curl
      branch_id: "",
      asset_code: "",
      sequence: 1,
      customer_id: "",
      finance_id: "",
      sale_id: "",
      part_id: "", // Item ID
      serial_number: "",
      price: "",
      
      // Location
      location_running_number: "",
      location_name: "",
      location_address: "",
      location_province: "",
      location_district: "",
      location_sub_district: "",
      location_zip_code: "",
      location_floor_room: "",
      latitude: "",
      longitude: "",
      location_remark: "",
      
      // Contact
      contract_name: "",
      contract_phone: "",
      contract_email: "",
      
      // Invoice
      invoice_number: "",
      invoice_date: "",
      coi_date: "",
      
      // Warranty
      customer_warranty: [{ customer_warranty_month: "", customer_warranty_expire_date: "" }],
      customer_warranty_count: 0,
      customer_warranty_remark: "",
      
      company_warranty: [{ company_warranty_month: "", company_warranty_expire_date: "" }],
      company_warranty_count: 0,
      company_warranty_remark: "",
      
      tag_name: "",
      tags: [],
      is_active: true,

      selected_cwc: "",
      cwc_attachments: [],

      currentPath: null
    };
  }

  async componentDidMount() {
    this.Get(1);
  }

  componentWillUnmount() {
    if (this.modalCloseTimer) {
      clearTimeout(this.modalCloseTimer);
    }
  }

  // --- API Functions ---

  Get = async (page = 1) => {
    let data = [], count = 0, data_customer = [], data_finance = [], data_sale = [], data_part = [], data_branch = [], data_cwc = [];
    const { filter_search, filter_customer, filter_status, filter_vendor_warranty } = this.state;
    loading(true);

    let [result, result_customer, result_finance, result_sale, result_part, result_branch, result_cwc] = await Promise.all([
      GET("admin/assets", {
        page_size: 10,
        page: page,
        data_search: filter_search || "",
        customer_id: filter_customer || "",
        is_active: filter_status || "",
        has_vendor_warranty: filter_vendor_warranty || "",
        type: "",
        uid: ""
      }),
      GET("admin/customers", {
        page_size: 10000,
        page: 0,
        data_search: "",
      }),
      GET("admin/finance-masters", {
        page_size: 10000,
        page: 0,
        data_search: "",
      }),
      GET("admin/sale-masters", {
        page_size: 10000,
        page: 0,
        data_search: "",
      }),
       GET("warehouse/part-masters", {
                page_size: 10000,
        page: 0,
        data_search: "",
              }),
      GET("warehouse/branches", {
        page_size: 10000,
        page: 0,
        data_search: "",
      }),
      GET("admin/customer-warranty-conditions", {
        page_size: 10000,
        page: 0,
        data_search: "",
      }),
    ]);

    if (result?.status) {
        data = result.data || [];
        count = result.pagination?.count || 0 ;
    }

    if(result_customer?.status){
      data_customer = result_customer.data.map(e => ({ ...e, value: e.uid || e.uid, label: e.customer_code + " " + (e.full_name_th || e.name) })) || [];
    }
    if(result_finance?.status){
      data_finance = result_finance.data.map(e => ({ value: e.uid || e.uid, label: e.finance_code + " " + e.finance_name_th })) || [];
    }
    if(result_sale?.status){
      data_sale = result_sale.data.map(e => ({ value: e.uid || e.uid, label: e.sale_code + " "+e.name_th })) || [];
    }

    if(result_part?.status){
      data_part = result_part.data.map(e => ({ ...e, value: e.uid || e.uid, label: e.part_number })) || [];
    }

    if(result_branch?.status){
      data_branch = result_branch.data.map(e => ({ ...e, value: e.uid, label: e.name })) || [];
    }

    if(result_cwc?.status){
      data_cwc = result_cwc.data
        .filter(e => e.is_active !== false)
        .map(e => ({ value: e.uid, label: (e.code ? e.code + " " : "") + (e.name || "") })) || [];
    }

    this.setState({ data, count, data_customer, data_finance, data_sale, data_part, data_branch, data_cwc });
    loading(false);
  };

  CreateUpdate = async (create_new) => {
    const {
      uid, company_id, branch_id, asset_code, sequence, customer_id, finance_id, sale_id, part_id, serial_number, price,
      location_running_number, location_name, location_address, location_province, location_district, location_sub_district, location_zip_code, location_floor_room, latitude, longitude, location_remark,
      contract_name, contract_phone, contract_email,
      invoice_number, invoice_date, coi_date,
      customer_warranty, customer_warranty_remark,
      company_warranty, company_warranty_remark,
      tag_name, tags, is_active, cwc_attachments,
    } = this.state;
    const normalizedContractEmail = (contract_email || "").trim();

    // Validate
    if (!branch_id) {
      alert("", "warning", t("warning"), t("validate_asset_branch"));
      return;
    }
    if (!customer_id) {
      alert("", "warning", t("warning"), t("validate_asset_customer"));
      return;
    }
    if (!part_id) {
          alert("", "warning", t("warning"), t("validate_asset_part"));
          return;
        }
    if (!serial_number) {
          alert("", "warning", t("warning"), t("validate_asset_serial_number"));
          return;
        }
    if (!price || parseFloat(price) < 0) {
        alert("", "warning", t("warning"), t("validate_asset_price"));
        return;
    }
    if (!location_name) {
          alert("", "warning", t("warning"), t("validate_asset_location_name"));
          return;
        }
    if (!location_address) {
          alert("", "warning", t("warning"), t("validate_asset_location_address"));
          return;
        }
    if (!location_province) {
          alert("", "warning", t("warning"), t("validate_asset_province"));
          return;
        }
    if (!location_district) {
          alert("", "warning", t("warning"), t("validate_asset_district"));
          return;
        }
    if (!location_sub_district) {
          alert("", "warning", t("warning"), t("validate_asset_sub_district"));
          return;
        }
    if (!invoice_number) {
          alert("", "warning", t("warning"), t("validate_asset_invoice_number"));
          return;
        }
    if (!invoice_date) {
          alert("", "warning", t("warning"), t("validate_asset_invoice_date"));
          return;
        }
    if (!coi_date) {
          alert("", "warning", t("warning"), t("validate_asset_coi_date"));
          return;
        }
    const normalizedCustomerWarranty = this.normalizeWarrantyEntries(
      customer_warranty,
      "customer_warranty_month",
      "customer_warranty_expire_date",
    );
    const normalizedCompanyWarranty = this.normalizeWarrantyEntries(
      company_warranty,
      "company_warranty_month",
      "company_warranty_expire_date",
    );

    if (!normalizedCustomerWarranty.length) {
      alert("", "warning", t("warning"), t("validate_asset_customer_warranty"));
      return;
    }
    if (!this.isWarrantyListComplete(normalizedCustomerWarranty, "customer_warranty_month", "customer_warranty_expire_date")) {
      alert("", "warning", t("warning"), t("validate_asset_customer_warranty_complete"));
      return;
    }
    if (normalizedContractEmail && !this.isValidEmail(normalizedContractEmail)) {
      alert("", "warning", t("warning"), t("invalid_email_address"));
      return;
    }

    if (await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel"))) {
      loading(true);

      const cwc_uploaded = await this.uploadCwcAttachments(cwc_attachments);
      if (cwc_uploaded === null) {
        loading(false);
        return;
      }

      let body = {
        company_id,
        branch_id: typeof branch_id === 'object' ? branch_id.value : branch_id,
        asset_code,
        sequence: Number(sequence) || 1,
        customer_id: typeof customer_id === 'object' ? customer_id.value : customer_id,
        finance_id,
        sale_id,
        part_id,
        serial_number,
        price: parseFloat(price) || 0,
        location_running_number,
        location_name,
        location_address,
        location_province,
        location_district,
        location_sub_district,
        location_zip_code,
        location_floor_room,
        latitude,
        longitude,
        location_remark,
        contract_name,
        contract_phone,
        contract_email: normalizedContractEmail,
        invoice_number,
        invoice_date: invoice_date || null,
        coi_date: coi_date || null,
        customer_warranty: normalizedCustomerWarranty.map((item) => ({
          customer_warranty_month: Number(item.customer_warranty_month) || 0,
          customer_warranty_expire_date: item.customer_warranty_expire_date || null,
        })),
        customer_warranty_count: normalizedCustomerWarranty.length,
        customer_warranty_remark,
        customer_warranty_attachments: cwc_uploaded,
        company_warranty: normalizedCompanyWarranty.map((item) => ({
          company_warranty_month: Number(item.company_warranty_month) || 0,
          company_warranty_expire_date: item.company_warranty_expire_date || null,
        })),
        company_warranty_count: normalizedCompanyWarranty.length,
        company_warranty_remark,
        tag_name,
        tags,
        is_active
      };

      let result = !uid
        ? await POST("admin/assets", body)
        : await PUT("admin/assets/" + uid, body);

      if (result?.status === true) {
        if(!create_new){
        alert("#", "success", t("success"), t("save_success"));
        this.closeModalWithAnimation("modal_create");
        this.Get(1);
        }else{
        this.openModalCreate();
        }
      } else {
        alert("", "warning", t("warning"), result?.message || t("error_occurred"));
      }
      loading(false);
    }
  };

  Delete = async (id) => {
    if (await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel"))) {
      loading(true);
      let result = await DELETE("admin/assets/" + id, null);
      if (result?.status) {
        alert("#", "success", t("success"), t("delete_success"));
        this.Get(1);
      } else {
        alert("", "warning", t("warning"), result?.message || t("error_occurred"));
      }
      loading(false);
    }
  };

  // --- Handlers ---

  closeModalWithAnimation = (modalKey) => {
    const closingKey = `${modalKey}_closing`;
    if (!this.state[modalKey] || this.state[closingKey]) {
      return;
    }

    if (this.modalCloseTimer) {
      clearTimeout(this.modalCloseTimer);
    }

    this.setState({ [closingKey]: true });
    this.modalCloseTimer = setTimeout(() => {
      this.setState({ [modalKey]: false, [closingKey]: false });
      this.modalCloseTimer = null;
    }, 220);
  };

  appendCwcToRemark = () => {
    const { selected_cwc, data_cwc, customer_warranty_remark } = this.state;
    if (!selected_cwc) return;
    const item = data_cwc.find(e => e.value === selected_cwc);
    if (!item) return;
    const current = customer_warranty_remark || "";
    const newText = current ? current + "\n" + item.label : item.label;
    if (newText.length > 500) {
      alert("", "warning", t("warning"), t("validate_remark_max_length"));
      return;
    }
    this.setState({ customer_warranty_remark: newText, selected_cwc: "" });
  };

  mapCwcFilesToItems = (files) =>
    Array.from(files).map((file) => ({
      file,
      name: file.name,
      size: file.size,
      type: file.type,
      url: URL.createObjectURL(file),
    }));

  filterValidCwcFiles = (files) => {
    const max = MAX_UPLOAD_SIZE.default;
    const arr = Array.from(files || []);
    const tooBig = arr.filter((f) => f.size > max);
    if (tooBig.length > 0) {
      const mb = Math.round(max / 1024 / 1024);
      alert("", "warning", t("warning"), `${t("file_too_large")} (${mb} MB): ${tooBig.map((f) => f.name).join(", ")}`);
    }
    return arr.filter((f) => f.size <= max);
  };

  handleCwcDragOver = (e) => e.preventDefault();

  handleCwcDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const newItems = this.mapCwcFilesToItems(this.filterValidCwcFiles(e.dataTransfer.files));
      this.setState((prev) => ({ cwc_attachments: [...prev.cwc_attachments, ...newItems] }));
      e.dataTransfer.clearData();
    }
  };

  removeCwcAttachment = async (index) => {
    if (!(await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel")))) return;
    this.setState((prev) => {
      const updated = [...prev.cwc_attachments];
      if (updated[index]?.url?.startsWith("blob:")) URL.revokeObjectURL(updated[index].url);
      updated.splice(index, 1);
      return { cwc_attachments: updated };
    });
  };

  uploadCwcAttachments = async (items) => {
    const uploaded = [];
    for (const item of items || []) {
      if (!item?.file && typeof item?.url === "string" && item.url.includes("://")) {
        uploaded.push({
          uid: item.uid || undefined,
          file_path: item.url,
          file_name: item.name || null,
          file_type: item.file_type || "document",
          mime_type: item.mime_type || null,
          file_size: item.file_size ?? null,
        });
        continue;
      }
      const max = MAX_UPLOAD_SIZE.default;
      if (item?.file && item.file.size > max) {
        const mb = Math.round(max / 1024 / 1024);
        alert("", "warning", t("warning"), `${t("file_too_large")} (${mb} MB): ${item?.name || ""}`);
        return null;
      }
      const res = await UPLOAD(item.file, { folder: "assets/customer-warranty-attachments" });
      if (res?.status === true && res?.data?.file_path) {
        uploaded.push({
          file_path: res.data.file_path,
          file_name: item.name || res.data.file_name || null,
          file_type: res.data.file_type || "document",
          mime_type: res.data.mime_type || item.type || null,
          file_size: res.data.file_size ?? item.size ?? null,
        });
      } else {
        alert("", "warning", t("warning"), `${t("upload")} "${item?.name || ""}" ${t("fail")}`);
        return null;
      }
    }
    return uploaded;
  };

  openModalCreate = () => {
    this.setState({
      modal_create: true,
      modal_create_closing: false,
      uid: "",
      asset_code: "",
      branch_id: "",
      sequence: 1, customer_id: "", finance_id: "", sale_id: "", part_id: "", serial_number: "", price: "",
      location_running_number: "", location_name: "", location_address: "", location_province: "", location_district: "", location_sub_district: "", location_zip_code: "", location_floor_room: "", latitude: "", longitude: "", location_remark: "",
      contract_name: "", contract_phone: "", contract_email: "",
      invoice_number: "", invoice_date: "", coi_date: "",
      customer_warranty: [{ customer_warranty_month: "", customer_warranty_expire_date: "" }], customer_warranty_count: 0, customer_warranty_remark: "",
      company_warranty: [{ company_warranty_month: "", company_warranty_expire_date: "" }], company_warranty_count: 0, company_warranty_remark: "",
      tag_name: "", tags: [], is_active: true, selected_cwc: "", cwc_attachments: [],
    });
  }

  openModalUpdate = async (item) => { 
    loading(true);
    let result = await GET("admin/assets", { uid: item.uid })
    if (result.status === true) {
      let data = result.data;
      const normalizedWarranty = this.normalizeAssetWarrantyState(data);
      this.setState({
        modal_create: true,
        modal_create_closing: false,
        ...data,
      ...normalizedWarranty,
      uid: data?.uid,
      branch_id: data?.branch?.uid || "",
      customer_id: data?.customer?.uid || "",
      finance_id: data?.finance?.uid || "",
      part_id: data?.part?.uid || "",
      sale_id: data?.sale?.uid || "",
      invoice_date: data?.invoice_date ? format_date(data?.invoice_date,"yyyy-mm-dd","en") : "",
      coi_date: data?.coi_date ? format_date(data?.coi_date,"yyyy-mm-dd","en") : "",
      selected_cwc: "",
      cwc_attachments: (data?.customer_warranty_attachments || []).map((a) => ({
        uid: a.uid,
        url: a.file_path,
        name: a.file_name || a.file_path?.split("/").pop() || "",
        file_type: a.file_type,
        mime_type: a.mime_type,
        file_size: a.file_size,
      })),

    });
    }
    loading(false);
  }
  openModalDetail = async (item) => {
    loading(true);
    let result = await GET("admin/assets", {uid: item.uid})
    if(result.status === true){
      let data = result.data;
      const normalizedWarranty = this.normalizeAssetWarrantyState(data);
      this.setState({
        modal_view: true,
        modal_view_closing: false,
        ...data,
      ...normalizedWarranty,
      uid: data?.uid,
      branch_id: data?.branch?.uid || "",
      customer_id: data?.customer?.uid || "",
      finance_id: data?.finance?.uid || "",
      part_id: data?.part?.uid || "",
      sale_id: data?.sale?.uid || "",
      invoice_date: data?.invoice_date ? format_date(data?.invoice_date,"yyyy-mm-dd","en") : "",
      coi_date: data?.coi_date ? format_date(data?.coi_date,"yyyy-mm-dd","en") : "",
      cwc_attachments: (data?.customer_warranty_attachments || []).map((a) => ({
        uid: a.uid,
        url: a.file_path,
        name: a.file_name || a.file_path?.split("/").pop() || "",
        file_type: a.file_type,
        mime_type: a.mime_type,
        file_size: a.file_size,
      })),

    });
    }
    loading(false);
  }

  normalizeWarrantyEntries = (entries, monthKey, expireKey) => {
    return (entries || []).filter(
      (item) =>
        item &&
        (
          String(item[monthKey] ?? "").trim() !== "" ||
          String(item[expireKey] ?? "").trim() !== ""
        ),
    );
  };

  normalizeAssetWarrantyState = (data = {}) => {
    const customerWarranty =
      data?.customer_warranty?.map((item) => ({
        customer_warranty_month: item?.customer_warranty_month?.toString?.() || item?.customer_warranty_month || "",
        customer_warranty_expire_date: item?.customer_warranty_expire_date
          ? format_date(item.customer_warranty_expire_date, "yyyy-mm-dd", "en")
          : "",
      })) ||
      [];

    const companyWarranty =
      data?.company_warranty?.map((item) => ({
        company_warranty_month: item?.company_warranty_month?.toString?.() || item?.company_warranty_month || "",
        company_warranty_expire_date: item?.company_warranty_expire_date
          ? format_date(item.company_warranty_expire_date, "yyyy-mm-dd", "en")
          : "",
      })) ||
      [];

    const normalizedCustomerWarranty = customerWarranty.length
      ? customerWarranty
      : [{
          customer_warranty_month: data?.customer_warranty_month?.toString?.() || data?.customer_warranty_month || "",
          customer_warranty_expire_date: data?.customer_warranty_expire_date
            ? format_date(data.customer_warranty_expire_date, "yyyy-mm-dd", "en")
            : "",
        }];

    const normalizedCompanyWarranty = companyWarranty.length
      ? companyWarranty
      : [{
          company_warranty_month: data?.company_warranty_month?.toString?.() || data?.company_warranty_month || "",
          company_warranty_expire_date: data?.company_warranty_expire_date
            ? format_date(data.company_warranty_expire_date, "yyyy-mm-dd", "en")
            : "",
        }];

    return {
      customer_warranty: normalizedCustomerWarranty,
      customer_warranty_count: normalizedCustomerWarranty.filter(
        (item) =>
          String(item.customer_warranty_month ?? "").trim() !== "" ||
          String(item.customer_warranty_expire_date ?? "").trim() !== "",
      ).length,
      company_warranty: normalizedCompanyWarranty,
      company_warranty_count: normalizedCompanyWarranty.filter(
        (item) =>
          String(item.company_warranty_month ?? "").trim() !== "" ||
          String(item.company_warranty_expire_date ?? "").trim() !== "",
      ).length,
    };
  };

  getLatestWarrantyExpireDate = (warrantyList, monthKey, expireKey, fallback = "") => {
    const normalizedList = this.normalizeWarrantyEntries(
      warrantyList,
      monthKey,
      expireKey,
    );
    const latestExpireDate = normalizedList.reduce((latest, item) => {
      const currentExpireDate = String(item?.[expireKey] || "").trim();

      if (!currentExpireDate) {
        return latest;
      }

      if (!latest) {
        return currentExpireDate;
      }

      return new Date(currentExpireDate) > new Date(latest) ? currentExpireDate : latest;
    }, "");

    return latestExpireDate || fallback || "";
  };

  getWarrantyBaseDate = (warrantyList, index, expireKey, coiDate) => {
    if (index === 0) {
      return coiDate || "";
    }

    return warrantyList?.[index - 1]?.[expireKey] || "";
  };

  updateWarrantyMonthValue = (section, index, value) => {
    const monthKey = `${section}_warranty_month`;
    const expireKey = `${section}_warranty_expire_date`;
    const warrantyKey = `${section}_warranty`;
    const warrantyList = [...(this.state[warrantyKey] || [])];
    const baseDate = this.getWarrantyBaseDate(warrantyList, index, expireKey, this.state.coi_date);

    warrantyList[index] = {
      ...warrantyList[index],
      [monthKey]: value,
      [expireKey]: baseDate && value !== "" ? this.addMonthsToDate(baseDate, value) : "",
    };

    this.setState({
      [warrantyKey]: warrantyList,
      [`${section}_warranty_count`]: this.normalizeWarrantyEntries(
        warrantyList,
        monthKey,
        expireKey,
      ).length,
    });
  };

  updateWarrantyExpireValue = (section, index, value) => {
    const monthKey = `${section}_warranty_month`;
    const expireKey = `${section}_warranty_expire_date`;
    const warrantyKey = `${section}_warranty`;
    const warrantyList = [...(this.state[warrantyKey] || [])];
    const baseDate = this.getWarrantyBaseDate(warrantyList, index, expireKey, this.state.coi_date);

    warrantyList[index] = {
      ...warrantyList[index],
      [expireKey]: value,
      [monthKey]: baseDate && value ? this.getMonthDiff(baseDate, value) : "",
    };

    this.setState({
      [warrantyKey]: warrantyList,
      [`${section}_warranty_count`]: this.normalizeWarrantyEntries(
        warrantyList,
        monthKey,
        expireKey,
      ).length,
    });
  };

  recalculateWarrantyList = (list, monthKey, expireKey, coiDate) => {
    return (list || []).reduce((acc, item, index) => {
      const baseDate = index === 0 ? coiDate : (acc[index - 1]?.[expireKey] || "");

      acc.push({
        ...item,
        [expireKey]:
          baseDate && item?.[monthKey] !== "" && item?.[monthKey] !== null
            ? this.addMonthsToDate(baseDate, item[monthKey])
            : "",
      });

      return acc;
    }, []);
  };

  addWarrantyEntry = (section) => {
    const monthKey = `${section}_warranty_month`;
    const expireKey = `${section}_warranty_expire_date`;
    const warrantyKey = `${section}_warranty`;
    const warrantyList = [...(this.state[warrantyKey] || [])];
    const latestEntry = warrantyList[warrantyList.length - 1];

    if (!latestEntry?.[monthKey] || !latestEntry?.[expireKey]) {
      alert("", "warning", t("warning"), t("validate_warranty_latest_entry_complete"));
      return;
    }

    warrantyList.push({ [monthKey]: "", [expireKey]: "" });

    this.setState({
      [warrantyKey]: warrantyList,
      [`${section}_warranty_count`]: this.normalizeWarrantyEntries(
        warrantyList,
        monthKey,
        expireKey,
      ).length,
    });
  };

  deleteWarrantyEntry = (section, index) => {
    const monthKey = `${section}_warranty_month`;
    const expireKey = `${section}_warranty_expire_date`;
    const warrantyKey = `${section}_warranty`;
    const currentList = [...(this.state[warrantyKey] || [])];
    const filteredList = currentList.filter((_, itemIndex) => itemIndex !== index);
    const nextList = filteredList.length
      ? this.recalculateWarrantyList(filteredList, monthKey, expireKey, this.state.coi_date)
      : [{ [monthKey]: "", [expireKey]: "" }];

    this.setState({
      [warrantyKey]: nextList,
      [`${section}_warranty_count`]: this.normalizeWarrantyEntries(
        nextList,
        monthKey,
        expireKey,
      ).length,
    });
  };

  isWarrantyListComplete = (warrantyList, monthKey, expireKey) => {
    return warrantyList.every(
      (item) =>
        Number(item?.[monthKey]) > 0 &&
        !!item?.[expireKey],
    );
  };

  isLatestWarrantyEntryComplete = (warrantyList, monthKey, expireKey) => {
    const latestEntry = warrantyList?.[warrantyList.length - 1];
    return Number(latestEntry?.[monthKey]) > 0 && !!latestEntry?.[expireKey];
  };

  getAssetLatestWarrantyExpireDate = (item, section) => {
    const warrantyKey = `${section}_warranty`;
    const monthKey = `${section}_warranty_month`;
    const expireKey = `${section}_warranty_expire_date`;

    const normalizedWarranty = this.normalizeAssetWarrantyState(item)?.[warrantyKey] || [];
    const latestExpireDate = this.getLatestWarrantyExpireDate(
      normalizedWarranty,
      monthKey,
      expireKey,
      item?.[expireKey] || "",
    );

    return latestExpireDate || item?.[expireKey] || "";
  };

  // ตรวจว่าวันหมดประกันเลยวันที่ปัจจุบันแล้วหรือยัง (ไม่มีวันที่ = ถือว่าหมดอายุ)
  isWarrantyExpired = (expireDate) => {
    const raw = String(expireDate || "").trim();
    if (!raw) return true;
    const parsed = new Date(raw.split("T")[0]);
    if (isNaN(parsed.getTime())) return true;
    parsed.setHours(0, 0, 0, 0);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return parsed < today;
  };

  addMonthsToDate = (dateString, months) => {
    if (!dateString || months === "" || months === null || months === undefined) {
      return "";
    }

    const parsedMonths = parseInt(months, 10);
    if (Number.isNaN(parsedMonths)) {
      return "";
    }

    const date = new Date(dateString);
    const originalDay = date.getDate();
    date.setMonth(date.getMonth() + parsedMonths);

    // Handle month overflow such as Jan 31 + 1 month.
    if (date.getDate() < originalDay) {
      date.setDate(0);
    }

    return date.toISOString().split("T")[0];
  };

  getMonthDiff = (startDateString, endDateString) => {
    if (!startDateString || !endDateString) {
      return 0;
    }

    const startDate = new Date(startDateString);
    const endDate = new Date(endDateString);

    let months =
      (endDate.getFullYear() - startDate.getFullYear()) * 12 +
      (endDate.getMonth() - startDate.getMonth());

    if (endDate.getDate() < startDate.getDate()) {
      months -= 1;
    }

    return months > 0 ? months : 0;
  };

  renderModalAnimationStyle = () => (
    <style>{`
      .asset-modal-backdrop {
        animation: assetBackdropFadeIn 180ms ease-out;
      }

      .asset-modal-dialog {
        animation: assetModalLiftIn 220ms ease-out;
        transform-origin: center center;
      }

      .asset-modal-backdrop.is-closing {
        animation: assetBackdropFadeOut 220ms ease-in forwards;
      }

      .asset-modal-dialog.is-closing {
        animation: assetModalLiftOut 220ms ease-in forwards;
      }

      @keyframes assetBackdropFadeIn {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }

      @keyframes assetModalLiftIn {
        from {
          opacity: 0;
          transform: translateY(14px) scale(0.985);
        }
        to {
          opacity: 1;
          transform: translateY(0) scale(1);
        }
      }

      @keyframes assetBackdropFadeOut {
        from {
          opacity: 1;
        }
        to {
          opacity: 0;
        }
      }

      @keyframes assetModalLiftOut {
        from {
          opacity: 1;
          transform: translateY(0) scale(1);
        }
        to {
          opacity: 0;
          transform: translateY(10px) scale(0.99);
        }
      }

      @media (prefers-reduced-motion: reduce) {
        .asset-modal-backdrop,
        .asset-modal-dialog {
          animation: none !important;
        }
      }
    `}</style>
  );

  // --- Modal Form ---
  renderUpdateModal = () => {
    const {
      modal_create, modal_create_closing, uid, data_customer,
      data_finance, data_sale,data_part, data_branch, data_cwc,
      asset_code, branch_id, customer_id, finance_id, sale_id, part_id, serial_number, price,
      location_running_number, location_name, location_address, location_province, location_district, location_sub_district, location_zip_code, location_floor_room, latitude, longitude, location_remark,
      contract_name, contract_phone, contract_email,
      invoice_number, invoice_date, coi_date,
      customer_warranty, customer_warranty_count, customer_warranty_remark,
      company_warranty, company_warranty_count, company_warranty_remark,
      is_active, tag_name, tags, selected_cwc, cwc_attachments,
    } = this.state;
    const normalizedContractEmail = contract_email || "";
    const contractEmailHasError = Boolean(normalizedContractEmail.trim()) && !this.isValidEmail(normalizedContractEmail);
    
    const latestCustomerWarrantyExpireDate = this.getLatestWarrantyExpireDate(
      customer_warranty,
      "customer_warranty_month",
      "customer_warranty_expire_date",
    );
    const latestCompanyWarrantyExpireDate = this.getLatestWarrantyExpireDate(
      company_warranty,
      "company_warranty_month",
      "company_warranty_expire_date",
    );
    const isLatestCustomerWarrantyComplete = this.isLatestWarrantyEntryComplete(
      customer_warranty,
      "customer_warranty_month",
      "customer_warranty_expire_date",
    );
    const isLatestCompanyWarrantyComplete = this.isLatestWarrantyEntryComplete(
      company_warranty,
      "company_warranty_month",
      "company_warranty_expire_date",
    );

    if (!modal_create) return null;

    const SectionHeader = ({ num, title, enTitle, icon }) => (
      <div className="d-flex align-items-center justify-content-between mb-4 border-bottom pb-2 mt-4">
        <div className="d-flex align-items-center">
          <div className="wpx-25 hpx-25 rounded bg-primary text-white d-flex align-items-center justify-content-center fw-bold me-2 text-12 shadow-sm">
            {num}
          </div>
          <h6 className="fw-bold mb-0 text-dark d-flex align-items-center">
            {icon && <span className="icon text-secondary me-2">{icon}</span>}
            {title}
          </h6>
        </div>
        <div className="text-muted text-12 text-uppercase">{enTitle}</div>
      </div>
    );

    return (
      <div
        className={`modal fade show d-block asset-modal-backdrop${modal_create_closing ? " is-closing" : ""}`}
        style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1050 }}
        onMouseDown={(e) => {
          if (e.target === e.currentTarget) {
            this.closeModalWithAnimation("modal_create");
          }
        }}
      >
        {this.renderModalAnimationStyle()}
        <div className={`modal-dialog modal-dialog-centered modal-fullscreen p-2 p-md-4 asset-modal-dialog${modal_create_closing ? " is-closing" : ""}`}>
          <div className="modal-content border-0 rounded-4 shadow bg-light overflow-hidden d-flex flex-column" style={{ maxHeight: "100%" }}>
            
            {/* Header */}
            <div className="modal-header border-bottom px-4 py-3 bg-white d-flex justify-content-between align-items-center">
              <div>
                <div className="text-primary text-12 mb-1 fw-bold">
                  {t("asset_management")} <span className="text-secondary mx-1">&gt;</span> <span className="text-dark">{uid ? t("edit_asset") : t("save_new_asset")}</span>
                </div>
                <h4 className="fw-bold mb-1 d-flex align-items-center text-dark">
                  <span className="icon me-2 text-secondary">{"\uf0c7"}</span> 
                  {uid ? t("edit_asset") : t("save_new_asset")}
                </h4>
                <div className="text-muted text-12">{t("asset_modal_create_subtitle")}</div>
              </div>
            </div>
            
            <div className="modal-body p-2 p-md-4 bg-light overflow-auto">
              
              {/* Stepper */}
              <div className="card border-0 shadow-sm rounded-4 p-2 p-md-4 mb-4 bg-white">
                <div className="d-flex justify-content-between align-items-center position-relative w-100 px-3">
                  <div className="position-absolute top-50 start-0 w-100 bg-light" style={{ height: "2px", zIndex: 0 }}></div>
                  
                  {[
                    { num: 1, label: t("section_customer_info"), en: "Customer", active: customer_id },
                    { num: 2, label: t("step_item_info"), en: "Item / Asset", active: customer_id && part_id && serial_number },
                    { num: 3, label: t("installation_location"), en: "Location", active: customer_id && part_id && serial_number && location_name && location_address && location_province && location_district && location_sub_district },
                    { num: 4, label: t("section_invoice_info"), en: "Invoice", active: customer_id && part_id && serial_number && location_name && location_address && location_province && location_district && location_sub_district && invoice_number && invoice_date && coi_date },
                    { num: 5, label: t("step_warranty_info"), en: "Warranty", active: customer_id && part_id && serial_number && location_name && location_address && location_province && location_district && location_sub_district && invoice_number && invoice_date && coi_date && customer_warranty_count > 0 && company_warranty_count > 0 && isLatestCustomerWarrantyComplete && isLatestCompanyWarrantyComplete },
                  ].map((step, idx) => (
                    <div key={idx} className="d-flex flex-column align-items-center position-relative bg-white px-2" style={{ zIndex: 1 }}>
                      <div className={`wpx-30 hpx-30 rounded-circle d-flex align-items-center justify-content-center fw-bold text-12 mb-2 ${step.active ? 'bg-primary text-white' : 'bg-light text-secondary border'}`}>
                        {step.num}
                      </div>
                      <div className={`fw-bold text-12 ${step.active ? 'text-dark' : 'text-secondary'}`}>{step.label}</div>
                      {/* <div className="text-muted text-12">{step.en}</div> */}
                    </div>
                  ))}
                </div>
              </div>

              <div className="row g-4">
                {/* Left Column - Main Form */}
                <div className="col-lg-8 col-xl-9">
                  <div className="card border-0 shadow-sm rounded-4 p-3 p-md-4 mb-3 mb-md-4 bg-white">
                    
                    {/* 1. ข้อมูลลูกค้า */}
                    <SectionHeader num="1" title={t("section_customer_info")} icon={"\uf0c0"} />
                    <div className="row g-3 mb-3 mb-md-4">
                      <div className="col-md-6">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_branch")} <span className="text-danger">*</span></label>
                        <Select
                          className="form-control text-12"
                          options={data_branch}
                          value={branch_id}
                          onChange={(e)=> this.setState({branch_id: e})}
                          placeholder={t("placeholder_select_branch")}
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_customer_id")} <span className="text-danger">*</span></label>
                        <Select
                          className="form-control text-12"
                          options={data_customer}
                          value={customer_id}
                          onChange={(e,i)=> this.setState({customer_id: e, location_running_number: (i.customer_code || "") + "-LOC-" + "00001"})}
                          placeholder={t("placeholder_select_example")}
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_finance_id")}</label>
                        <Select
                          className="form-control text-12"
                          options={data_finance}
                          value={finance_id}
                          onChange={(e)=> this.setState({finance_id: e})}
                          placeholder={t("placeholder_select_example")}
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_salesperson")}</label>
                        <Select
                          className="form-control text-12"
                          options={data_sale}
                          value={sale_id}
                          onChange={(e)=> this.setState({sale_id: e})}
                          placeholder={t("placeholder_select_example")}
                        />
                      </div>
                    </div>

                    {/* 2. ข้อมูลสินค้า / เครื่องจักร */}
                    <SectionHeader num="2" title={t("section_item_info")} icon={"\uf1b3"} />
                    <div className="row g-3 mb-3 mb-md-4">
                      <div className="col-12 text-primary fw-bold text-12"><span className="icon me-1">{"\uf466"}</span> {t("heading_item_info")}</div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_item_id")} <span className="text-danger">*</span></label>
                         <Select
                          className="form-control text-12"
                          options={data_part}
                          value={part_id}
                          onChange={(e,i)=> this.setState({part_id: e, price : i.selling_price || ""})}
                          placeholder={t("placeholder_select_example")}
                        />
                      </div>
                      <div className="col-md-8">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_product_name")}</label>
                        <input type="text" className="form-control bg-light text-12" placeholder="" value={data_part?.find(e=>e.value === part_id)?.name} readOnly />
                      </div>
                      <div className="col-md-3">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_brand")}</label>
                        <input type="text" className="form-control bg-light text-12" placeholder="" value={data_part?.find(e=>e.value === part_id)?.brand?.name} readOnly />
                      </div>
                      <div className="col-md-3">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_category_1")}</label>
                        <input type="text" className="form-control bg-light text-12" placeholder="" value={data_part?.find(e=>e.value === part_id)?.part_category?.name} readOnly />
                      </div>
                      <div className="col-md-3">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_series_1")}</label>
                        <input type="text" className="form-control bg-light text-12" placeholder="" value={data_part?.find(e=>e.value === part_id)?.model?.name} readOnly />
                      </div>
                      <div className="col-md-3">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_model_2")}</label>
                        <input type="text" className="form-control bg-light text-12" placeholder="" value={data_part?.find(e=>e.value === part_id)?.serie?.name} readOnly />
                      </div>

                      <div className="col-12 text-primary fw-bold text-12 mt-3"><span className="icon me-1">{"\uf0ad"}</span> {t("heading_machine_details")}</div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_serial_no")} <span className="text-danger">*</span></label>
                        <input type="text" className="form-control text-12" value={serial_number} onChange={e => this.setState({ serial_number: e.target.value })} placeholder={t("placeholder_serial_number_example")} />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_machine_price_before_discount")} <span className="text-danger">*</span></label>
                        <input type="number" className="form-control text-12" value={price} onChange={e => this.setState({ price: e.target.value })} placeholder="115000" />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_status")} <span className="text-danger">*</span></label>
                        <select className="form-select text-12" value={is_active ? "true" : "false"} onChange={e => this.setState({ is_active: e.target.value === "true" })}>
                          <option value="true">{t("option_active_status")}</option>
                          <option value="false">{t("option_inactive_status")}</option>
                        </select>
                      </div>
                    </div>

                    {/* 3. สถานที่ติดตั้ง */}
                    <SectionHeader num="3" title={t("installation_location")} icon={"\uf3c5"} />
                    <div className="row g-3 mb-3 mb-md-4">
                      <div className="col-md-6">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_location_id")}</label>
                        <div className="position-relative">
                          <span className="position-absolute ext-primary icon" style={{left:10, top:5}}>{"\uf3c5"}</span>
                          <input type="text" className="form-control bg-white text-primary fw-bold text-12" disabled style={{paddingLeft:30}} value={location_running_number} readOnly />
                        </div>
                      </div>
                      <div className="col-md-6 d-flex align-items-end justify-content-end">
                        <div className="bg-success-light text-success px-3 py-2 rounded-2 text-12 fw-bold border border-success">
                           {t("hint_location_id_format")}
                        </div>
                      </div>

                      <div className="col-12 text-primary fw-bold text-12 mt-3"><span className="icon me-1 text-danger">{"\uf3c5"}</span> {t("heading_location_info")}</div>
                      <div className="col-md-6">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_location_name")} <span className="text-danger">*</span></label>
                        <input type="text" className="form-control text-12" value={location_name} onChange={e => this.setState({ location_name: e.target.value })} placeholder={t("placeholder_location_name_example")} />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_address")} <span className="text-danger">*</span></label>
                        <input type="text" className="form-control text-12" value={location_address} onChange={e => this.setState({ location_address: e.target.value })} placeholder={t("placeholder_address_example")} />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("province")} <span className="text-danger">*</span></label>
                        <select className="form-select text-12" value={location_province} onChange={e => this.setState({ location_province: e.target.value, location_district: "",location_sub_district: "", location_zip_code: ""})}>
                          <option value="">{t("option_select_province")}</option>
                          {PROVINCE.map(e=>(
                            <option key={e.th} th={e.value}>{e.th}</option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_district")} <span className="text-danger">*</span></label>
                        <select className="form-select text-12" value={location_district} disabled={!location_province} onChange={e => this.setState({ location_district: e.target.value,location_sub_district: "", location_zip_code: "" })}>
                          <option value="">{t("option_select_district")}</option>
                          {PROVINCE.find(e=>e.th === location_province)?.district?.map(e=>(
                            <option key={e.th} th={e.value}>{e.th}</option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_sub_district")} <span className="text-danger">*</span></label>
                        <select className="form-select text-12" value={location_sub_district} disabled={!location_district} onChange={(e) => {
                          // 1. หา option ที่ผู้ใช้กำลังเลือกอยู่
                          const selectedOption = e.target.options[e.target.selectedIndex];
                          // 2. ดึงค่าจาก attribute 'data-code' ที่เราฝังไว้
                          const zipCode = selectedOption.getAttribute('data-code') || "";
                          
                          // 3. อัปเดตทั้งตำบลและรหัสไปรษณีย์พร้อมกัน
                          this.setState({ 
                            location_sub_district: e.target.value, 
                            location_zip_code: zipCode 
                          });
                        }}>
                          <option value="">{t("option_select_sub_district")}</option>
                          {PROVINCE.find(e=>e.th === location_province)?.district?.find(e=>e.th === location_district)?.sub_district?.map(e=>(
                            <option data-code={e.code} key={e.th} th={e.value}>{e.th}</option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("postal_code")}</label>
                        <input type="text" className="form-control text-12" value={location_zip_code} disabled placeholder="10160" />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_floor_room")}</label>
                        <input type="text" className="form-control text-12" value={location_floor_room} onChange={e => this.setState({ location_floor_room: e.target.value })} placeholder={t("placeholder_floor_room_example")} />
                      </div>
                      <div className="col-md-4"></div>
                      
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_latitude")}</label>
                        <div className="position-relative">
                          <span className="position-absolute ext-primary icon" style={{left:10, top:5}}>{"\uf3c5"}</span>
                          <input type="text" className="form-control text-12" style={{paddingLeft:30}} value={latitude} onChange={e => this.setState({ latitude: e.target.value })} placeholder="13.722321" />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_longitude")}</label>
                        <div className="position-relative">
                          <span className="position-absolute ext-primary icon" style={{left:10, top:5}}>{"\uf3c5"}</span>
                          <input type="text" className="form-control text-12" style={{paddingLeft:30}} value={longitude} onChange={e => this.setState({ longitude: e.target.value })} placeholder="100.581782" />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_pin_from_map")}</label>
                        <button className="btn btn-outline-primary w-100 fw-bold text-12 d-flex align-items-center justify-content-center bg-primary-light" onClick={() => {this.setState({modal_create: false, modal_create_closing: false, modal_map:true, currentPath: latitude ? {lat: latitude, lng: longitude} : null})}}>
                          <span className="icon me-2">{"\uf279"}</span> {t("btn_pin_location")}
                        </button>
                      </div>

                      <div className="col-12 text-primary fw-bold text-12 mt-3"><span className="icon me-1 text-info">{"\uf007"}</span> {t("heading_location_contact")}</div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_contact_name")}</label>
                        <input type="text" className="form-control text-12" value={contract_name} onChange={e => this.setState({ contract_name: e.target.value })} placeholder={t("placeholder_contact_name_example")} />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("phone_number")}</label>
                        <input type="text" className="form-control text-12" value={contract_phone} maxLength={10} onChange={e => {
                          if(!float(e.target.value)) return;
                          this.setState({ contract_phone: e.target.value })}} placeholder="081-234-5678" />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("email")}</label>
                        <input
                          type="email"
                          className={`form-control text-12${contractEmailHasError ? " is-invalid" : ""}`}
                          value={contract_email || ""}
                          onChange={e => this.setState({ contract_email: e.target.value })}
                          placeholder="contact@example.com"
                        />
                        {contractEmailHasError && (
                          <div className="invalid-feedback">{t("invalid_email_address")}</div>
                        )}
                      </div>
                      <div className="col-12">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_location_remark")}</label>
                        <textarea className="form-control text-12" rows="2" value={location_remark} onChange={e => this.setState({ location_remark: e.target.value })} placeholder={t("placeholder_location_remark_example")}></textarea>
                      </div>
                    </div>

                    {/* 4. ข้อมูลการจำหน่าย */}
                    <SectionHeader num="4" title={t("section_invoice_info")} icon={"\uf571"} />
                    <div className="row g-3 mb-3 mb-md-4">
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_invoice_no")} <span className="text-danger">*</span></label>
                        <input type="text" className="form-control text-12" value={invoice_number} onChange={e => this.setState({ invoice_number: e.target.value })} placeholder="BPSB-IVT-69010094" />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_invoice_date")} <span className="text-danger">*</span></label>
                        <DatePicker type="th" className="form-control text-12" value={invoice_date} onChange={val => this.setState({ invoice_date: val })} />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">
                          {t("eoi_date")} <span className="text-danger">*</span>
                        </label>
                        <DatePicker
                          type="th"
                          className="form-control text-12"
                          value={coi_date}
                          onChange={val => {
                            const newCoiDate = val;
                            this.setState({
                              coi_date: newCoiDate,
                              customer_warranty: this.recalculateWarrantyList(
                                customer_warranty,
                                "customer_warranty_month",
                                "customer_warranty_expire_date",
                                newCoiDate,
                              ),
                              company_warranty: this.recalculateWarrantyList(
                                company_warranty,
                                "company_warranty_month",
                                "company_warranty_expire_date",
                                newCoiDate,
                              ),
                            });
                          }} 
                        />
                      </div>
                    </div>

                    {/* 5. ข้อมูลการรับประกัน */}
                    <SectionHeader num="5" title={t("section_warranty_info")} icon={"\uf132"} />
                    <div className="row g-3">
                      <div className="col-12 d-flex justify-content-between align-items-center text-primary fw-bold text-12 mt-2">
                        <div><span className="icon me-1 text-primary">{"\uf3ed"}</span> {t("warranty_customer")}</div>
                        <button type="button" className="btn btn-outline-primary btn-sm fw-bold" onClick={() => this.addWarrantyEntry("customer")}>
                          <span className="icon me-1">{"\uf067"}</span> {t("add")}
                        </button>
                      </div>
                      {customer_warranty.map((item, index) => {
                        const isLatest = index === customer_warranty.length - 1;
                        const baseDate = this.getWarrantyBaseDate(
                          customer_warranty,
                          index,
                          "customer_warranty_expire_date",
                          coi_date,
                        );

                        return (
                          <div key={`customer-warranty-${index}`} className="col-12">
                            <div
                              className="card rounded-4 p-3 position-relative bg-white"
                              style={{
                                outline: "1px solid #dddde0",
                              }}
                            >
                              {customer_warranty.length > 1 && (
                                <button
                                  type="button"
                                  className="d-flex align-items-center justify-content-center position-absolute bg-white border border-danger text-danger"
                                  style={{
                                    top: "12px",
                                    right: "12px",
                                    width: "28px",
                                    minWidth: "28px",
                                    height: "28px",
                                    padding: 0,
                                    borderRadius: "999px",
                                    lineHeight: 1,
                                  }}
                                  onClick={() => this.deleteWarrantyEntry("customer", index)}
                                >
                                  <span className="icon text-14">{"\uf00d"}</span>
                                </button>
                              )}
                              <div className="text-primary fw-bold text-12 mb-3">
                                {t("customer_warranty_period_no")} {index + 1}
                              </div>
                              <div className="row g-3">
                                <div className="col-md-4">
                                  <label className="form-label text-secondary fw-bold text-12">
                                    {t("label_customer_warranty_ext")} ({t("unit_month")}) {index === 0 ? required : ""}
                                  </label>
                                  <input
                                    type="number"
                                    className="form-control text-12"
                                    value={item.customer_warranty_month}
                                    disabled={!isLatest}
                                    onChange={e => this.updateWarrantyMonthValue("customer", index, e.target.value)}
                                    placeholder="0"
                                  />
                                  <div className="text-muted text-12 mt-1">
                                    {index === 0
                                      ? t("calculated_from_coi_date")
                                      : `${t("continue_from_previous_period")} (${baseDate ? format_date(baseDate, "dd-mm-yyyy", "th") : "-"})`}
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <label className="form-label text-secondary fw-bold text-12">{t("label_customer_warranty_end")}</label>
                                  <DatePicker
                                    type="th"
                                    className="form-control text-12"
                                    value={item.customer_warranty_expire_date}
                                    disabled={!isLatest}
                                    onChange={val => this.updateWarrantyExpireValue("customer", index, val)}
                                  />
                                  <div className="text-primary text-12 mt-1">
                                    <span className="icon">{"\uf044"}</span> {t("hint_auto_calculate_base_plus_months")}
                                  </div>
                                </div>
                                <div className="col-md-4" hidden>
                                  <label className="form-label text-secondary fw-bold text-12">{t("base_date")}</label>
                                  <input
                                    type="text"
                                    className="form-control text-12 bg-light"
                                    value={baseDate ? format_date(baseDate, "dd mmm yyyy", "th") : ""}
                                    readOnly
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_warranty_ext_count")}</label>
                        <input type="number" className="form-control text-12 bg-light" value={customer_warranty_count} readOnly placeholder="0" />
                      </div>
                      <div className="col-12">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_customer_warranty_remark")}</label>
                        <textarea className="form-control text-12" rows="2" maxLength={500} value={customer_warranty_remark} onChange={e => this.setState({ customer_warranty_remark: e.target.value })} placeholder={t("placeholder_customer_warranty_remark_example")}></textarea>
                        <div className="d-flex align-items-center gap-2 mt-2">
                          <div className="flex-grow-1">
                            <Select
                              className="form-control text-12"
                              options={data_cwc}
                              value={selected_cwc}
                              onChange={(e) => this.setState({ selected_cwc: e })}
                              placeholder={t("placeholder_select_cwc")}
                            />
                          </div>
                          <button type="button" className="btn btn-outline-primary btn-sm fw-bold px-3 text-nowrap" onClick={this.appendCwcToRemark}>
                            + {t("add")}
                          </button>
                        </div>
                        <div className="text-muted text-12 mt-1 text-end">{(customer_warranty_remark || "").length} / 500</div>
                      </div>

                      {/* CWC Attachments */}
                      <div className="col-12">
                        <label className="form-label text-secondary fw-bold text-12">
                          <span className="icon me-1">{""}</span> {t("label_attachment")}
                        </label>
                        <div
                          className="border rounded-3 p-3 mb-2 text-center pointer"
                          style={{ borderStyle: "dashed", borderColor: "#ccc", backgroundColor: "#fafafa" }}
                          onDragOver={this.handleCwcDragOver}
                          onDrop={this.handleCwcDrop}
                          onClick={() => document.getElementById("cwc-file-upload").click()}
                        >
                          <input
                            type="file"
                            id="cwc-file-upload"
                            multiple
                            accept="application/pdf,image/*,.doc,.docx,.xls,.xlsx"
                            hidden
                            onChange={(e) => {
                              const newItems = this.mapCwcFilesToItems(this.filterValidCwcFiles(e.target.files));
                              this.setState((prev) => ({ cwc_attachments: [...prev.cwc_attachments, ...newItems] }));
                              e.target.value = "";
                            }}
                          />
                          <div className="text-secondary text-12 fw-bold">{t("hint_click_or_drag_file")}</div>
                          <div className="text-muted text-10 mt-1">{t("hint_file_type_size_limit")}</div>
                        </div>
                        {cwc_attachments.length > 0 && (
                          <div className="d-flex flex-wrap gap-2 mt-2">
                            {cwc_attachments.map((file, i) => {
                              const isImage = file.type?.startsWith("image/") || file.mime_type?.startsWith("image/") || /\.(jpg|jpeg|png|gif|webp)$/i.test(file.name || "");
                              return (
                                <div key={i} className="border rounded-3 p-2 text-center position-relative bg-light" style={{ width: "90px" }}>
                                  <div
                                    className="position-absolute top-0 end-0 bg-danger text-white rounded-circle wpx-15 hpx-15 d-flex align-items-center justify-content-center pointer"
                                    style={{ transform: "translate(30%, -30%)", zIndex: 2 }}
                                    onClick={() => this.removeCwcAttachment(i)}
                                  >
                                    <span className="icon text-10">{""}</span>
                                  </div>
                                  {isImage ? (
                                    <a href={file.url} target="_blank" rel="noopener noreferrer">
                                      <img src={file.url} alt={file.name} className="rounded-2 mb-1" style={{ width: "100%", height: "55px", objectFit: "cover" }} />
                                    </a>
                                  ) : (
                                    <a href={file.url} target="_blank" rel="noopener noreferrer" className="d-block mb-1">
                                      <span className="icon text-primary" style={{ fontSize: "2rem" }}>{""}</span>
                                    </a>
                                  )}
                                  <div className="text-10 text-secondary text-truncate" title={file.name}>{file.name}</div>
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>

                      <div className="col-12 d-flex justify-content-between align-items-center text-success fw-bold text-12 mt-4">
                        <div><span className="icon me-1 text-success">{"\uf3ed"}</span> {t("warranty_vendor")}</div>
                        <span className="text-muted text-12 fw-normal">{t("hint_vendor_warranty_edit_restriction")}</span>
                      </div>
                      {(company_warranty.length ? company_warranty : [{ company_warranty_month: "", company_warranty_expire_date: "" }]).map((item, index) => (
                        <div key={`company-warranty-${index}`} className="col-12">
                          <div className="card rounded-4 p-3 bg-light" style={{ outline: "1px solid #dddde0" }}>
                            <div className="text-success fw-bold text-12 mb-3">
                              {t("company_warranty_period_no")} {index + 1}
                            </div>
                            <div className="row g-3">
                              <div className="col-md-6">
                                <label className="form-label text-secondary fw-bold text-12">
                                  {t("label_vendor_warranty_ext")} ({t("unit_month")})
                                </label>
                                <input type="number" className="form-control text-12 bg-light" value={item.company_warranty_month} readOnly placeholder="0" />
                              </div>
                              <div className="col-md-6">
                                <label className="form-label text-secondary fw-bold text-12">{t("label_vendor_warranty_end")}</label>
                                <input
                                  type="text"
                                  className="form-control text-12 bg-light"
                                  value={item.company_warranty_expire_date ? format_date(item.company_warranty_expire_date, "dd-mm-yyyy", "th") : ""}
                                  readOnly
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_warranty_ext_count")}</label>
                        <input type="number" className="form-control text-12 bg-light" value={company_warranty_count} readOnly placeholder="0" />
                      </div>
                      <div className="col-12">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_vendor_warranty_remark")}</label>
                        <textarea className="form-control text-12 bg-light" rows="2" value={company_warranty_remark} readOnly placeholder={t("placeholder_vendor_warranty_remark")}></textarea>
                      </div>
                    </div>

                  </div>
                </div>

                {/* Right Column - Sidebar Summary */}
                <div className="col-lg-4 col-xl-3">
                  
                  {/* ASSET ID Box */}
                  <div className="card border-0 shadow-sm rounded-4 p-3 mb-3 bg-white">
                    <div className="text-secondary fw-bold text-12 mb-2"><span className="icon me-1">{"\uf02a"}</span> {t("asset_id_auto_label")}</div>
                    <div className="bg-primary-light text-primary fw-bold text-12 text-center py-2 rounded-3 mb-2 border border-primary">
                      {asset_code || t("hint_asset_code_auto_generate")}
                    </div>
                    
                    <div className="text-success fw-bold text-12 mb-1"><span className="icon me-1">{"\uf3c5"}</span> {t("label_location_id")}</div>
                    <div className="bg-success-light text-success fw-bold text-12 text-center py-2 rounded-3 border border-success">
                      {location_running_number || t("hint_location_id_auto_generate")}
                    </div>
                  </div>

                  {/* สรุปข้อมูล Summary */}
                  <div className="card border-0 shadow-sm rounded-4 p-3 mb-3 bg-white">
                    <h6 className="fw-bold text-dark border-bottom pb-2 mb-3 d-flex align-items-center">
                      <span className="icon me-2 text-secondary">{"\uf0cb"}</span> {t("heading_summary")}
                    </h6>
                    <div className="d-flex justify-content-between mb-2 text-12">
                      <span className="text-muted">{t("customer")}</span>
                      <span className="fw-bold text-dark text-end">{data_customer?.find(e=>e.value === customer_id)?.full_name_th || ""}<br/><span className="text-muted fw-normal text-12">{data_customer?.find(e=>e.value === customer_id)?.customer_code || ""}</span></span>
                    </div>
                    <div className="d-flex justify-content-between mb-2 text-12">
                      <span className="text-muted">{t("label_product_short")}</span>
                      <span className="fw-bold text-dark text-end">{data_part?.find(e=>e.value === part_id)?.name || ""}</span>
                    </div>
                    <div className="d-flex justify-content-between mb-2 text-12">
                      <span className="text-muted">{t("label_brand_model")}</span>
                      <span className="fw-bold text-dark text-end">{data_part?.find(e=>e.value === part_id)?.brand?.name || ""} {data_part?.find(e=>e.value === part_id)?.modal?.name || ""}</span>
                    </div>
                    <div className="d-flex justify-content-between mb-2 text-12">
                      <span className="text-muted">{t("label_serial_no")}</span>
                      <span className="fw-bold text-dark text-end">{serial_number || ""}</span>
                    </div>
                    <div className="d-flex justify-content-between mb-2 text-12 mt-2 pt-2 border-top">
                      <span className="text-muted text-nowrap"><span className="icon text-danger me-1">{"\uf3c5"}</span> {t("label_location_short")}</span>
                      <span className="fw-bold text-primary text-end">{location_name}<br/>
                      <span className="text-muted fw-normal text-12">
                        {location_address}{location_sub_district ? ` ต.${location_sub_district}`: ""}{location_district ? ` อ.${location_district}`: ""}{location_province ? ` จ.${location_province}`: ""} {location_zip_code}
                      </span>
                      </span>
                    </div>
                    <div className="d-flex justify-content-between mb-2 text-12">
                      <span className="text-muted">{t("label_contact_short")}</span>
                      <span className="fw-bold text-dark text-end">{contract_name || ""}</span>
                    </div>
                    <div className="d-flex justify-content-between mb-2 text-12 mt-2 pt-2 border-top">
                      <span className="text-muted">{t("coi_date")}</span>
                      <span className="fw-bold text-dark text-end">{coi_date ? format_date(coi_date,"dd-mm-yyyy","th") : ""}</span>
                    </div>
                    <div className="d-flex justify-content-between mb-2 text-12">
                      <span className="text-muted">{t("warranty_customer")}</span>
                      <span className="fw-bold text-success text-end">{latestCustomerWarrantyExpireDate ? (<span>{format_date(latestCustomerWarrantyExpireDate,"dd-mm-yyyy","th")}<span className="icon">{"\uf00c"}</span></span>) : ""}</span>
                    </div>
                    <div className="d-flex justify-content-between mb-2 text-12">
                      <span className="text-muted">{t("warranty_vendor")}</span>
                      <span className="fw-bold text-success text-end">{latestCompanyWarrantyExpireDate ? (<span>{format_date(latestCompanyWarrantyExpireDate,"dd-mm-yyyy","th")}<span className="icon">{"\uf00c"}</span></span>) : ""}</span>
                    </div>
                    <div className="d-flex justify-content-between mb-2 text-12 mt-2 pt-2 border-top">
                      <span className="text-muted">{t("label_machine_price_short")}</span>
                      <span className="fw-bold text-dark text-end">{toFixed(price)} {t("baht")}</span>
                    </div>
                  </div>

                  {/* ความครบถ้วน Checklist */}
                  <div className="card border-0 shadow-sm rounded-4 p-3 mb-3 bg-white">
                    <h6 className="fw-bold text-success border-bottom pb-2 mb-3 d-flex align-items-center">
                      <span className="icon me-2 text-success">{"\uf058"}</span> {t("heading_completeness")}
                    </h6>
                    <div className="d-flex flex-column gap-2 text-12">
                      <div className={customer_id ? "text-success" : "text-warning"}><span className="icon me-2">{customer_id ? "\uf058" : "\uf06a"}</span> {t("checklist_customer_info")}</div>
                      <div className={part_id && serial_number ? "text-success" : "text-warning"}><span className="icon me-2">{part_id && serial_number ? "\uf058" : "\uf06a"}</span> {t("checklist_item_serial")}</div>
                      <div className={location_name && location_address && location_province && location_district && location_sub_district && location_zip_code ? "text-success" : "text-warning"}><span className="icon me-2">{location_name && location_address && location_province && location_district && location_sub_district && location_zip_code ? "\uf058" : "\uf06a"}</span> {t("checklist_location")}</div>
                      <div className={invoice_number && invoice_date ? "text-success" : "text-warning"}><span className="icon me-2">{invoice_number && invoice_date ? "\uf058" : "\uf06a"}</span> {t("checklist_invoice")}</div>
                      <div className={coi_date ? "text-success" : "text-warning"}><span className="icon me-2">{coi_date ? "\uf058" : "\uf06a"}</span> {t("checklist_coi_date")}</div>
                      <div className={customer_warranty_count > 0 && isLatestCustomerWarrantyComplete ? "text-success" : "text-warning"}><span className="icon me-2">{customer_warranty_count > 0 && isLatestCustomerWarrantyComplete ? "\uf058" : "\uf06a"}</span> {t("checklist_customer_warranty")}</div>
                      <div className={company_warranty_count > 0 && isLatestCompanyWarrantyComplete ? "text-success" : "text-warning"}><span className="icon me-2">{company_warranty_count > 0 && isLatestCompanyWarrantyComplete ? "\uf058" : "\uf06a"}</span> {t("checklist_vendor_warranty")}</div>
                    </div>
                  </div>

                  {/* Tags */}
                  <div className="card border-0 shadow-sm rounded-4 p-3 mb-3 bg-white">
                    <h6 className="fw-bold text-dark border-bottom pb-2 mb-3 d-flex align-items-center">
                      <span className="icon me-2 text-secondary">{"\uf02b"}</span> Tags
                    </h6>
                    <div className="d-flex flex-wrap gap-2 mb-2">
                      {tags.map((t,i) => (
                      <span className="badge bg-primary-light text-primary border border-primary fw-normal">{t} <span className="icon ms-1 pointer" onClick={() => {this.setState({tags: tags.filter(e=>e!==t)})}}>{"\uf00d"}</span></span>
                      ))}
                    </div>
                    <input type="text" className="form-control text-12" placeholder={t("placeholder_add_tag")} value={tag_name} onChange={e => this.setState({ tag_name: e.target.value })} onKeyUp={e => {
                      if(e.key === "Enter"){
                        this.setState({tags: [...tags,tag_name],tag_name: ""})
                      }
                    }}/>
                  </div>

                </div>
              </div>
            </div>
            
            {/* Footer fixed */}
            <div className="modal-footer px-4 py-3 bg-white border-top d-flex justify-content-between align-items-center w-100 mt-auto">
              <div className="text-warning text-12 fw-bold d-flex align-items-center">
                <span className="icon me-2">{"\uf071"}</span> {t("footer_note_check_before_save")}
              </div>
              <div className="d-flex gap-2">
                <button type="button" className="btn btn-white border fw-bold px-4 text-secondary bg-white shadow-sm" onClick={() => this.closeModalWithAnimation("modal_create")}>
                  <span className="icon me-1">{"\uf00d"}</span> {t("cancel")}
                </button>
                {/* <button type="button" className="btn btn-outline-success fw-bold px-4 shadow-sm bg-success-light" onClick={() => this.CreateUpdate(true)}>
                  <span className="icon me-2">{"\uf067"}</span> บันทึก & สร้างใหม่
                </button> */}
                <button type="button" className="btn btn-primary fw-bold px-4 d-flex align-items-center shadow-sm" onClick={() => this.CreateUpdate()}>
                  <span className="icon me-2">{"\uf0c7"}</span> {t("save")}
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    );
  }
  renderDetailModal = () => {
    const { 
      modal_view, modal_view_closing, uid, data_customer,
      data_finance, data_sale, data_part, data_branch,
      asset_code, branch_id, customer_id, finance_id, sale_id, part_id, serial_number, price,
      location_running_number, location_name, location_address, location_province, location_district, location_sub_district, location_zip_code, location_floor_room, latitude, longitude, location_remark,
      contract_name, contract_phone, contract_email,
      invoice_number, invoice_date, coi_date,
      customer_warranty, customer_warranty_count, customer_warranty_remark,
      company_warranty, company_warranty_count, company_warranty_remark,
      is_active, tags, cwc_attachments,
    } = this.state;

    const latestCustomerWarrantyExpireDate = this.getLatestWarrantyExpireDate(
      customer_warranty,
      "customer_warranty_month",
      "customer_warranty_expire_date",
    );
    const latestCompanyWarrantyExpireDate = this.getLatestWarrantyExpireDate(
      company_warranty,
      "company_warranty_month",
      "company_warranty_expire_date",
    );
    const detailCustomerWarranty = this.normalizeWarrantyEntries(
      customer_warranty,
      "customer_warranty_month",
      "customer_warranty_expire_date",
    );
    const detailCompanyWarranty = this.normalizeWarrantyEntries(
      company_warranty,
      "company_warranty_month",
      "company_warranty_expire_date",
    );

    if (!modal_view) return null;

    const SectionHeader = ({ num, title, enTitle, icon }) => (
      <div className="d-flex align-items-center justify-content-between mb-4 border-bottom pb-2 mt-4">
        <div className="d-flex align-items-center">
          <div className="wpx-25 hpx-25 rounded bg-primary text-white d-flex align-items-center justify-content-center fw-bold me-2 text-12 shadow-sm">
            {num}
          </div>
          <h6 className="fw-bold mb-0 text-dark d-flex align-items-center">
            {icon && <span className="icon text-secondary me-2">{icon}</span>}
            {title}
          </h6>
        </div>
        <div className="text-muted text-12 text-uppercase">{enTitle}</div>
      </div>
    );

    // Component ช่วยสำหรับแสดงข้อมูลเป็นกล่องข้อความ Read-only
    const ViewBox = ({ value }) => (
      <div className="form-control bg-light text-12 text-dark" style={{ minHeight: "34px", overflow: "hidden", textOverflow: "ellipsis" }}>
        {value || "-"}
      </div>
    );

    return (
      <div
        className={`modal fade show d-block asset-modal-backdrop${modal_view_closing ? " is-closing" : ""}`}
        style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1050 }}
        onMouseDown={(e) => {
          if (e.target === e.currentTarget) {
            this.closeModalWithAnimation("modal_view");
          }
        }}
      >
        {this.renderModalAnimationStyle()}
        <div className={`modal-dialog modal-dialog-centered modal-fullscreen p-2 p-md-4 asset-modal-dialog${modal_view_closing ? " is-closing" : ""}`}>
          <div className="modal-content border-0 rounded-4 shadow bg-light overflow-hidden d-flex flex-column" style={{ maxHeight: "100%" }}>
            
            {/* Header */}
            <div className="modal-header border-bottom px-4 py-3 bg-white d-flex justify-content-between align-items-center">
              <div>
                <div className="text-primary text-12 mb-1 fw-bold">
                  {t("asset_management")} <span className="text-secondary mx-1">&gt;</span> <span className="text-dark">{t("label_asset_detail")}</span>
                </div>
                <h4 className="fw-bold mb-1 d-flex align-items-center text-dark">
                  <span className="icon me-2 text-secondary">{"\uf0cb"}</span>
                  {t("label_asset_detail")}
                </h4>
                <div className="text-muted text-12">{t("subtitle_asset_detail")}</div>
              </div>
              <button type="button" className="btn-close" onClick={() => this.closeModalWithAnimation("modal_view")}></button>
            </div>
            
            <div className="modal-body p-2 p-md-4 bg-light overflow-auto">
              
              {/* Stepper (แสดงสถานะแบบ Active ทั้งหมดเพราะเป็น View) */}
              <div className="card border-0 shadow-sm rounded-4 p-2 p-md-4 mb-4 bg-white">
                <div className="d-flex justify-content-between align-items-center position-relative w-100 px-3">
                  <div className="position-absolute top-50 start-0 w-100 bg-light" style={{ height: "2px", zIndex: 0 }}></div>
                  
                  {[
                    { num: 1, label: t("section_customer_info"), en: "Customer" },
                    { num: 2, label: t("step_item_info"), en: "Item / Asset" },
                    { num: 3, label: t("installation_location"), en: "Location" },
                    { num: 4, label: t("section_invoice_info"), en: "Invoice" },
                    { num: 5, label: t("step_warranty_info"), en: "Warranty" },
                  ].map((step, idx) => (
                    <div key={idx} className="d-flex flex-column align-items-center position-relative bg-white px-2" style={{ zIndex: 1 }}>
                      <div className={`wpx-30 hpx-30 rounded-circle d-flex align-items-center justify-content-center fw-bold text-12 mb-2 bg-primary text-white`}>
                        {step.num}
                      </div>
                      <div className="fw-bold text-12 text-dark">{step.label}</div>
                      {/* <div className="text-muted text-12">{step.en}</div> */}
                    </div>
                  ))}
                </div>
              </div>

              <div className="row g-4">
                {/* Left Column - Main Form Data */}
                <div className="col-lg-8 col-xl-9">
                  <div className="card border-0 shadow-sm rounded-4 p-3 p-md-4 mb-3 mb-md-4 bg-white">
                    
                    {/* 1. ข้อมูลลูกค้า */}
                    <SectionHeader num="1" title={t("section_customer_info")} icon={"\uf0c0"} />
                    <div className="row g-3 mb-3 mb-md-4">
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_branch")}</label>
                        <ViewBox value={data_branch?.find(e=>e.value === branch_id)?.label} />
                      </div>
                      <div className="col-md-8">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_customer")}</label>
                        <ViewBox value={data_customer?.find(e=>e.value === customer_id)?.full_name_th || data_customer?.find(e=>e.value === customer_id)?.label} />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_finance")}</label>
                        <ViewBox value={data_finance?.find(e=>e.value === finance_id)?.label || "-"} />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_salesperson")}</label>
                        <ViewBox value={data_sale?.find(e=>e.value === sale_id)?.label || "-"} />
                      </div>
                    </div>

                    {/* 2. ข้อมูลสินค้า / เครื่องจักร */}
                    <SectionHeader num="2" title={t("section_item_info")} icon={"\uf1b3"} />
                    <div className="row g-3 mb-3 mb-md-4">
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_item_id")}</label>
                        <ViewBox value={data_part?.find(e=>e.value === part_id)?.label || part_id} />
                      </div>
                      <div className="col-md-8">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_product_name")}</label>
                        <ViewBox value={data_part?.find(e=>e.value === part_id)?.name} />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_brand")}</label>
                        <ViewBox value={data_part?.find(e=>e.value === part_id)?.brand?.name} />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_model")}</label>
                        <ViewBox value={data_part?.find(e=>e.value === part_id)?.modal?.name} />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_category")}</label>
                        <ViewBox value={data_part?.find(e=>e.value === part_id)?.part_category?.name} />
                      </div>

                      <div className="col-12 text-primary fw-bold text-12 mt-3"><span className="icon me-1">{"\uf0ad"}</span> {t("heading_machine_details")}</div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_serial_no")}</label>
                        <ViewBox value={serial_number} />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_machine_price")}</label>
                        <ViewBox value={price ? `${Number(price).toLocaleString()} ${t("baht")}` : "-"} />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_status")}</label>
                        <div className={`form-control text-12 fw-bold ${is_active === "true" || is_active === true ? 'bg-success-light text-success' : 'bg-secondary-light text-secondary'}`}>
                          {is_active === "true" || is_active === true ? t("option_active_status") : t("option_inactive_status")}
                        </div>
                      </div>
                    </div>

                    {/* 3. สถานที่ติดตั้ง */}
                    <SectionHeader num="3" title={t("installation_location")} icon={"\uf3c5"} />
                    <div className="row g-3 border rounded-3 px-1 py-2 p-md-3 bg-light bg-opacity-50 mx-0 mb-3 mb-md-4">
                      <div className="col-md-6">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_location_id")}</label>
                        <ViewBox value={location_running_number} />
                      </div>
                      <div className="col-md-6"></div>

                      <div className="col-md-6 mt-3">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_location_name")}</label>
                        <ViewBox value={location_name} />
                      </div>
                      <div className="col-md-6 mt-3">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_address")}</label>
                        <ViewBox value={location_address} />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("province")}</label>
                        <ViewBox value={location_province} />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_district")}</label>
                        <ViewBox value={location_district} />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_sub_district")}</label>
                        <ViewBox value={location_sub_district} />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("postal_code")}</label>
                        <ViewBox value={location_zip_code} />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_floor_room")}</label>
                        <ViewBox value={location_floor_room} />
                      </div>
                      <div className="col-md-4"></div>
                      
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_latitude")}</label>
                        <ViewBox value={latitude} />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_longitude")}</label>
                        <ViewBox value={longitude} />
                      </div>

                      <div className="col-12 text-primary fw-bold text-12 mt-3"><span className="icon me-1 text-info">{"\uf007"}</span> {t("heading_location_contact")}</div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_contact_name")}</label>
                        <ViewBox value={contract_name} />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("phone_number")}</label>
                        <ViewBox value={contract_phone} />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("email")}</label>
                        <ViewBox value={contract_email} />
                      </div>
                      <div className="col-12">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_location_remark")}</label>
                        <div className="form-control bg-light text-12 text-dark" style={{ minHeight: "60px" }}>
                          {location_remark || "-"}
                        </div>
                      </div>
                    </div>

                    {/* 4. ข้อมูลการจำหน่าย */}
                    <SectionHeader num="4" title={t("section_invoice_info")} icon={"\uf571"} />
                    <div className="row g-3 mb-3 mb-md-4">
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_invoice_no")}</label>
                        <ViewBox value={invoice_number} />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_invoice_date")}</label>
                        <ViewBox value={invoice_date ? format_date(invoice_date, "dd-mm-yyyy", "th") : "-"} />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("eoi_date")}</label>
                        <ViewBox value={coi_date ? format_date(coi_date, "dd-mm-yyyy", "th") : "-"} />
                      </div>
                    </div>

                    {/* 5. ข้อมูลการรับประกัน */}
                    <SectionHeader num="5" title={t("section_warranty_info")} icon={"\uf132"} />
                    <div className="row g-3">
                      <div className="col-12 text-primary fw-bold text-12 mt-2"><span className="icon me-1 text-primary">{"\uf3ed"}</span> {t("warranty_customer")}</div>
                      {(detailCustomerWarranty.length ? detailCustomerWarranty : [{ customer_warranty_month: "-", customer_warranty_expire_date: "" }]).map((item, index) => (
                        <React.Fragment key={`detail-customer-warranty-${index}`}>
                          <div className="col-md-4">
                            <label className="form-label text-secondary fw-bold text-12">{t("label_customer_warranty_ext")} ({t("unit_month")})</label>
                            <ViewBox value={item.customer_warranty_month} />
                          </div>
                          <div className="col-md-4">
                            <label className="form-label text-secondary fw-bold text-12">{t("label_customer_warranty_end")}</label>
                            <ViewBox value={item.customer_warranty_expire_date ? format_date(item.customer_warranty_expire_date, "dd-mm-yyyy", "th") : "-"} />
                          </div>
                          <div className="col-md-4">
                            <label className="form-label text-secondary fw-bold text-12">{t("label_warranty_period")}</label>
                            <ViewBox value={`${t("sequence_no_label")} ${index + 1}`} />
                          </div>
                        </React.Fragment>
                      ))}
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_warranty_claim_count")}</label>
                        <ViewBox value={customer_warranty_count} />
                      </div>
                      <div className="col-12">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_customer_warranty_remark")}</label>
                        <div className="form-control bg-light text-12 text-dark" style={{ minHeight: "60px" }}>
                          {customer_warranty_remark || "-"}
                        </div>
                      </div>

                      {cwc_attachments && cwc_attachments.length > 0 && (
                        <div className="col-12">
                          <label className="form-label text-secondary fw-bold text-12">
                            <span className="icon me-1">{""}</span> {t("label_attachment_view")}
                          </label>
                          <div className="d-flex flex-wrap gap-2 mt-1">
                            {cwc_attachments.map((file, i) => {
                              const isImage = (file.file_type || "").startsWith("image") || /\.(png|jpe?g|gif|webp|bmp|svg)(\?|$)/i.test(file.url || "");
                              return (
                                <a key={i} href={file.url} target="_blank" rel="noopener noreferrer"
                                  className="d-flex flex-column align-items-center text-decoration-none border rounded-3 bg-white p-2 shadow-sm"
                                  style={{ width: 80, minHeight: 80, cursor: "pointer" }}
                                  title={file.name}
                                >
                                  {isImage ? (
                                    <img src={file.url} alt={file.name} style={{ width: 56, height: 56, objectFit: "cover", borderRadius: 6 }} />
                                  ) : (
                                    <div className="d-flex align-items-center justify-content-center text-secondary" style={{ width: 56, height: 56, fontSize: 28 }}>
                                      <span className="icon">{""}</span>
                                    </div>
                                  )}
                                  <div className="text-10 text-muted mt-1 text-center" style={{ wordBreak: "break-all", maxWidth: 72, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                    {file.name}
                                  </div>
                                </a>
                              );
                            })}
                          </div>
                        </div>
                      )}

                      <div className="col-12 text-success fw-bold text-12 mt-4"><span className="icon me-1 text-success">{"\uf3ed"}</span> {t("warranty_vendor")}</div>
                      {(detailCompanyWarranty.length ? detailCompanyWarranty : [{ company_warranty_month: "-", company_warranty_expire_date: "" }]).map((item, index) => (
                        <React.Fragment key={`detail-company-warranty-${index}`}>
                          <div className="col-md-4">
                            <label className="form-label text-secondary fw-bold text-12">{t("label_vendor_warranty_ext")} ({t("unit_month")})</label>
                            <ViewBox value={item.company_warranty_month} />
                          </div>
                          <div className="col-md-4">
                            <label className="form-label text-secondary fw-bold text-12">{t("label_vendor_warranty_end")}</label>
                            <ViewBox value={item.company_warranty_expire_date ? format_date(item.company_warranty_expire_date, "dd-mm-yyyy", "th") : "-"} />
                          </div>
                          <div className="col-md-4">
                            <label className="form-label text-secondary fw-bold text-12">{t("label_warranty_period")}</label>
                            <ViewBox value={`${t("sequence_no_label")} ${index + 1}`} />
                          </div>
                        </React.Fragment>
                      ))}
                      <div className="col-md-4">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_warranty_claim_count")}</label>
                        <ViewBox value={company_warranty_count} />
                      </div>
                      <div className="col-12">
                        <label className="form-label text-secondary fw-bold text-12">{t("label_vendor_warranty_remark")}</label>
                        <div className="form-control bg-light text-12 text-dark" style={{ minHeight: "60px" }}>
                          {company_warranty_remark || "-"}
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

                {/* Right Column - Sidebar Summary */}
                <div className="col-lg-4 col-xl-3">
                  
                  {/* ASSET ID Box */}
                  <div className="card border-0 shadow-sm rounded-4 p-3 mb-3 bg-white">
                    <div className="text-secondary fw-bold text-12 mb-2"><span className="icon me-1">{"\uf02a"}</span> {t("asset_id")}</div>
                    <div className="bg-primary-light text-primary fw-bold text-14 text-center py-2 rounded-3 mb-2 border border-primary">
                      {asset_code || "-"}
                    </div>
                    
                    <div className="text-success fw-bold text-12 mb-1 mt-3"><span className="icon me-1">{"\uf3c5"}</span> {t("label_location_id")}</div>
                    <div className="bg-success-light text-success fw-bold text-12 text-center py-2 rounded-3 border border-success">
                      {location_running_number || "-"}
                    </div>
                  </div>

                  {/* สรุปข้อมูล Summary */}
                  <div className="card border-0 shadow-sm rounded-4 p-3 mb-3 bg-white">
                    <h6 className="fw-bold text-dark border-bottom pb-2 mb-3 d-flex align-items-center">
                      <span className="icon me-2 text-secondary">{"\uf0cb"}</span> {t("heading_summary")}
                    </h6>
                    <div className="d-flex justify-content-between mb-2 text-12">
                      <span className="text-muted">{t("customer")}</span>
                      <span className="fw-bold text-dark text-end">{data_customer?.find(e=>e.value === customer_id)?.full_name_th || "-"}<br/><span className="text-muted fw-normal text-12">{data_customer?.find(e=>e.value === customer_id)?.customer_code || ""}</span></span>
                    </div>
                    <div className="d-flex justify-content-between mb-2 text-12">
                      <span className="text-muted">{t("label_product_short")}</span>
                      <span className="fw-bold text-dark text-end">{data_part?.find(e=>e.value === part_id)?.name || "-"}</span>
                    </div>
                    <div className="d-flex justify-content-between mb-2 text-12">
                      <span className="text-muted">{t("label_brand_model")}</span>
                      <span className="fw-bold text-dark text-end">{data_part?.find(e=>e.value === part_id)?.brand?.name || ""} {data_part?.find(e=>e.value === part_id)?.modal?.name || ""}</span>
                    </div>
                    <div className="d-flex justify-content-between mb-2 text-12">
                      <span className="text-muted">{t("label_serial_no")}</span>
                      <span className="fw-bold text-dark text-end">{serial_number || "-"}</span>
                    </div>
                    <div className="d-flex justify-content-between mb-2 text-12 mt-2 pt-2 border-top">
                      <span className="text-muted text-nowrap"><span className="icon text-danger me-1">{"\uf3c5"}</span> {t("label_location_short")}</span>
                      <span className="fw-bold text-primary text-end">{location_name || "-"}<br/>
                      <span className="text-muted fw-normal text-12">
                        {location_address}{location_sub_district ? ` ต.${location_sub_district}`: ""}{location_district ? ` อ.${location_district}`: ""}{location_province ? ` จ.${location_province}`: ""} {location_zip_code}
                      </span>
                      </span>
                    </div>
                    <div className="d-flex justify-content-between mb-2 text-12">
                      <span className="text-muted">{t("label_contact_short")}</span>
                      <span className="fw-bold text-dark text-end">{contract_name || "-"}</span>
                    </div>
                    <div className="d-flex justify-content-between mb-2 text-12 mt-2 pt-2 border-top">
                      <span className="text-muted">{t("coi_date")}</span>
                      <span className="fw-bold text-dark text-end">{coi_date ? format_date(coi_date,"dd-mm-yyyy","th") : "-"}</span>
                    </div>
                    <div className="d-flex justify-content-between mb-2 text-12">
                      <span className="text-muted">{t("warranty_customer")}</span>
                      <span className="fw-bold text-end">
                        {latestCustomerWarrantyExpireDate ? <span className="text-success">{format_date(latestCustomerWarrantyExpireDate,"dd-mm-yyyy","th")}<span className="icon ms-1">{"\uf00c"}</span></span> : <span className="text-danger">{t("expired")}</span>}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between mb-2 text-12">
                      <span className="text-muted">{t("warranty_vendor")}</span>
                      <span className="fw-bold text-end">
                        {latestCompanyWarrantyExpireDate ? <span className="text-success">{format_date(latestCompanyWarrantyExpireDate,"dd-mm-yyyy","th")}<span className="icon ms-1">{"\uf00c"}</span></span> : <span className="text-danger">{t("expired")}</span>}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between mb-2 text-12 mt-2 pt-2 border-top">
                      <span className="text-muted">{t("label_machine_price_short")}</span>
                      <span className="fw-bold text-dark text-end">{price ? Number(price).toLocaleString() : "0"} {t("baht")}</span>
                    </div>
                  </div>

                  {/* Tags */}
                  <div className="card border-0 shadow-sm rounded-4 p-3 mb-3 bg-white">
                    <h6 className="fw-bold text-dark border-bottom pb-2 mb-3 d-flex align-items-center">
                      <span className="icon me-2 text-secondary">{"\uf02b"}</span> Tags
                    </h6>
                    <div className="d-flex flex-wrap gap-2 mb-2">
                      {tags && tags.length > 0 ? tags.map((t,i) => (
                        <span key={i} className="badge bg-primary-light text-primary border border-primary fw-normal py-1 px-2 text-12">{t}</span>
                      )) : <span className="text-muted text-12">{t("label_no_tags")}</span>}
                    </div>
                  </div>

                </div>
              </div>
            </div>
            
            {/* Footer fixed */}
            <div className="modal-footer px-4 py-3 bg-white border-top d-flex justify-content-end align-items-center w-100 mt-auto">
              <button type="button" className="btn btn-outline-secondary fw-bold px-4 bg-white shadow-sm" onClick={() => this.closeModalWithAnimation("modal_view")}>
                <span className="icon me-1">{"\uf00d"}</span> {t("close")}
              </button>
            </div>

          </div>
        </div>
      </div>
    );
  }

  render() {
    const {
      modal_map, data, count, filter_search, filter_customer, filter_category, filter_status, filter_vendor_warranty, data_customer, currentPath
    } = this.state;

    // นับให้ตรงกับสถานะสีแดงในตาราง list (ประกันหมดอายุแล้ว = วันหมดประกัน < วันนี้ หรือไม่มีวันที่)
    const customerWarrantyExpiringCount = (data || []).filter(
      (item) => this.isWarrantyExpired(this.getAssetLatestWarrantyExpireDate(item, "customer"))
    ).length;
    const vendorWarrantyExpiringCount = (data || []).filter(
      (item) => this.isWarrantyExpired(this.getAssetLatestWarrantyExpireDate(item, "company"))
    ).length;

    return (
        <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
            <NavbarAdmin />
            <div className="body p-4 mt-3">
                {/* Header Section */}
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
                    <div>
                        <h3 className="fw-bold mb-1 text-dark">{t("asset_management")}</h3>
                        <div className="text-secondary text-14">{t("subtitle_asset_management_page")}</div>
                    </div>
                </div>

                {/* Top KPI Cards */}
                <div className="row g-3 mb-4">
                    <div className="col-lg-3 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                            <div className="d-flex align-items-center">
                                <div className="wpx-40 hpx-40 me-3 rounded bg-light text-secondary d-flex align-items-center justify-content-center text-20 icon">{"\uf02f"}</div>
                                <div>
                                    <h4 className="fw-bold text-dark mb-0">{count}</h4>
                                    <div className="text-secondary text-12">{t("total_assets")}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                            <div className="d-flex align-items-center">
                                <div className="wpx-40 hpx-40 me-3 rounded bg-success-light text-success d-flex align-items-center justify-content-center text-20 icon">{"\uf058"}</div>
                                <div>
                                    <h4 className="fw-bold text-success mb-0">{data.filter((e) => e.is_active).length}</h4>
                                    <div className="text-secondary text-12">{t("active")}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                            <div className="d-flex align-items-center">
                                <div className="wpx-40 hpx-40 me-3 rounded bg-danger-light text-danger d-flex align-items-center justify-content-center text-20 icon">{"\uf071"}</div>
                                <div>
                                    <h4 className="fw-bold text-danger mb-0">{customerWarrantyExpiringCount}</h4>
                                    <div className="text-secondary text-12">{t("customer_warranty_expiring")}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                            <div className="d-flex align-items-center">
                                <div className="wpx-40 hpx-40 me-3 rounded bg-danger-light text-danger d-flex align-items-center justify-content-center text-20 icon">{"\uf071"}</div>
                                <div>
                                    <h4 className="fw-bold text-danger mb-0">{vendorWarrantyExpiringCount}</h4>
                                    <div className="text-secondary text-12">{t("vendor_warranty_expiring")}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main White Container & Filters */}
                <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
                    {/* Top Filter Toolbar */}
                    <div className="d-flex flex-wrap justify-content-between align-items-center">
                        <div className="d-flex gap-2 flex-wrap">
                            <div className="position-relative flex-grow-1" style={{ maxWidth: "250px" }}>
                                <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">{"\uf002"}</span>
                                <input
                                    type="text"
                                    className="form-control ps-5 wpx-250"
                                    style={{ height: "38px" }}
                                    placeholder={t("search_assets")}
                                    value={filter_search}
                                    onChange={(e) => this.setState({ filter_search: e.target.value })}
                                />
                            </div>

                            <Select
                                className="form-control wpx-180"
                                options={data_customer}
                                value={filter_customer}
                                onChange={(e) => {
                                    this.setState({ filter_customer: e });
                                }}
                                placeholder={t("select_customer")}
                            />
                            <select className="form-select wpx-150" value={filter_status} onChange={(e) => this.setState({ filter_status: e.target.value })}>
                                <option value="">{t("all_status")}</option>
                                <option value="true">{t("active")}</option>
                                <option value="false">{t("inactive")}</option>
                            </select>
                            <select className="form-select wpx-200" value={filter_vendor_warranty} onChange={(e) => this.setState({ filter_vendor_warranty: e.target.value })}>
                                <option value="">{t("all_vendor_warranty")}</option>
                                <option value="false">{t("no_vendor_warranty")}</option>
                                <option value="true">{t("has_vendor_warranty")}</option>
                            </select>
                            <div className="d-flex gap-2">
                                <button className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.Get(1)}>
                                    {t("filter")}
                                </button>
                                <button
                                    className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm"
                                    onClick={() => this.setState({ filter_search: "", filter_status: "", filter_customer: "", filter_vendor_warranty: "" }, () => this.Get(1))}
                                >
                                    {t("clear_all")}
                                </button>
                            </div>
                        </div>

                        <div className="ms-auto d-flex gap-2">
                            {/* <button className="btn btn-white bg-white border px-3 py-2 fw-bold rounded-3 shadow-sm text-dark d-flex align-items-center">
                                <span className="icon me-2 text-14">{"\uf019"}</span> Export
                            </button> */}
                            <button className="btn btn-primary px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center" onClick={this.openModalCreate}>
                                <span className="me-2 text-16">+</span> {t("btn_add_asset")}
                            </button>
                        </div>
                    </div>
                </div>

                {/* Table */}
                <div className="bg-white rounded-4 shadow-sm pb-2">
                    <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0" style={{ minWidth: "1900px" }}>
                            <thead>
                                <tr className="text-muted fw-bold text-12 border-bottom border-light text-uppercase">
                                    <th className="py-3 border-0">{t("asset_id")}</th>
                                    <th className="py-3 border-0">{t("product_name")}</th>
                                    <th className="py-3 border-0">{t("customer")}</th>
                                    <th className="py-3 border-0">{t("category_1")}</th>
                                    <th className="py-3 border-0">{t("brand_model_1_header")}</th>
                                    <th className="py-3 border-0">{t("serial_no")}</th>
                                    <th className="py-3 border-0">{t("invoice_no")}</th>
                                    <th className="py-3 border-0">{t("eoi_date")}</th>
                                    <th className="py-3 border-0">{t("warranty_customer")}</th>
                                    <th className="py-3 border-0">{t("warranty_vendor")}</th>
                                    <th className="py-3 border-0 text-center">{t("status")}</th>
                                    <th className="py-3 border-0 text-center">{t("actions")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.length === 0 ? (
                                    <tr>
                                        <td colSpan="12" className="text-center py-4 text-secondary">
                                            {t("no_data_found")}
                                        </td>
                                    </tr>
                                ) : (
                                    data.map((item, idx) => {
                                        const latestCustomerWarrantyExpireDate = this.getAssetLatestWarrantyExpireDate(item, "customer");
                                        const latestCompanyWarrantyExpireDate = this.getAssetLatestWarrantyExpireDate(item, "company");
                                        const isCustomerWarrantyExpired = this.isWarrantyExpired(latestCustomerWarrantyExpireDate);
                                        const isCompanyWarrantyExpired = this.isWarrantyExpired(latestCompanyWarrantyExpireDate);
                                        return (
                                            <tr key={idx} className="border-bottom border-light bg-white">
                                                <td className="text-nowrap">
                                                    <span className="fw-bold text-primary text-12 pointer hover-underline">{item.asset_code || "-"}</span>
                                                </td>
                                                <td className="text-nowrap">
                                                    <div className="d-flex align-items-center">
                                                        <div className="wpx-30 hpx-30 rounded bg-light d-flex align-items-center justify-content-center me-2 text-secondary">
                                                            <span className="icon text-12">{"\uf02f"}</span>
                                                        </div>
                                                        <div>
                                                            <div className="fw-bold text-dark text-12">{item.part.name || "-"}</div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className="text-nowrap">
                                                    <div className="text-dark fw-bold text-12">{item.customer.full_name_th || "-"}</div>
                                                    <div className="text-secondary text-12">{item.customer.customer_code || ""}</div>
                                                </td>
                                                <td className="text-nowrap">
                                                    <span className="text-primary text-12">{item.part?.part_category?.name || "-"}</span>
                                                </td>
                                                <td className="text-nowrap">
                                                    <div className="text-dark fw-bold text-12">{item.part?.brand?.name || "-"}</div>
                                                    <div className="text-secondary text-12">{item.part?.model?.name || ""}</div>
                                                </td>
                                                <td className="text-nowrap">
                                                    <span className="text-dark text-12">{item.serial_number || "-"}</span>
                                                </td>
                                                <td className="text-nowrap">
                                                    <span className="text-dark text-12">{item.invoice_number || "-"}</span>
                                                </td>
                                                <td className="text-nowrap">
                                                    <span className="text-dark text-12">{item.coi_date ? format_date(item.coi_date.split("T")[0], "dd-mm-yyyy", "th") : "-"}</span>
                                                </td>
                                                <td className="text-nowrap">
                                                    <span className={`text-12 fw-bold ${!isCustomerWarrantyExpired ? "text-success" : "text-danger"}`}>
                                                        {latestCustomerWarrantyExpireDate ? (
                                                            <>
                                                                <span className="icon me-1">{isCustomerWarrantyExpired ? "\uf00d" : "\uf00c"}</span>
                                                                {format_date(latestCustomerWarrantyExpireDate.split("T")[0], "dd-mm-yyyy", "th")}
                                                            </>
                                                        ) : (
                                                            <>
                                                                <span className="icon me-1">-</span>
                                                            </>
                                                        )}
                                                    </span>
                                                </td>
                                                <td className="text-nowrap">
                                                    <span className={`text-12 fw-bold ${!isCompanyWarrantyExpired ? "text-success" : "text-danger"}`}>
                                                        {latestCompanyWarrantyExpireDate ? (
                                                            <>
                                                                <span className="icon me-1">{isCompanyWarrantyExpired ? "\uf00d" : "\uf00c"}</span>
                                                                {format_date(latestCompanyWarrantyExpireDate.split("T")[0], "dd-mm-yyyy", "th")}
                                                            </>
                                                        ) : (
                                                            <>
                                                                <span className="icon me-1">-</span>
                                                            </>
                                                        )}
                                                    </span>
                                                </td>
                                                <td className="text-center">
                                                    <span
                                                        className={`badge bg-${item.is_active ? "success" : "secondary"}-light text-${
                                                            item.is_active ? "success" : "secondary"
                                                        } rounded-pill px-2 py-1 fw-bold text-12`}
                                                    >
                                                        {item.is_active ? `● ${t("active")}` : `● ${t("inactive")}`}
                                                    </span>
                                                </td>
                                                <td className="text-center">
                                                    <div className="d-flex justify-content-center gap-2 text-secondary text-14">
                                                        <span className="icon pointer hover-primary transition-hover rounded-circle mx-1" title={t("view")} onClick={() => this.openModalDetail(item)}>
                                                            {"\uf06e"}
                                                        </span>
                                                        <span
                                                            className="icon pointer hover-warning transition-hover text-warning rounded-circle mx-1"
                                                            title={t("edit")}
                                                            onClick={() => this.openModalUpdate(item)}
                                                        >
                                                            {"\uf044"}
                                                        </span>
                                                        <span
                                                            className="icon pointer hover-danger transition-hover text-danger rounded-circle mx-1"
                                                            title={t("delete")}
                                                            onClick={() => this.Delete(item.id || item.uid)}
                                                        >
                                                            {"\uf2ed"}
                                                        </span>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Footer Pagination */}
                    <div className="d-flex justify-content-between align-items-center p-3 text-secondary text-12 bg-white border-top">
                        <div>
                            {t("showing")} 1-{data.length} {t("of")} {count} {t("assets")}
                        </div>
                        <Pagination className="mb-0" count={Math.ceil(count / 10) || 1} showFirstButton={false} showLastButton={false} onChange={(_, page) => this.Get(page)} />
                    </div>
                </div>
            </div>

            {/* Modal Create/Update */}
            {this.renderUpdateModal()}
            {this.renderDetailModal()}

            <Modal show={modal_map} onHide={() => this.setState({ modal_map: false })} size={"fullscreen"}>
                <Modal.Header className="border-0 pb-2" closeButton>
                    <h5 className="fw-bold mb-0">{t("label_pin_from_map")}</h5>
                </Modal.Header>
                <Modal.Body className="p-0">
                    <div className="position-relative" style={{ height: "80vh" }}>
                        <LoadScript googleMapsApiKey={process.env.REACT_APP_API_MAP_KEY} libraries={["geometry"]}>
                            <GoogleMap
                                mapContainerStyle={{ height: "100%", width: "100%" }}
                                center={
                                    // ถ้ามีการปักหมุดแล้วให้ center เลื่อนตามหมุด แต่ถ้ายังให้ใช้ค่าเริ่มต้น
                                    this.state.currentPath || { lat: 18.9076, lng: 99.046 }
                                }
                                zoom={10}
                                onClick={(e) => {
                                    this.setState({
                                        currentPath: { lat: e.latLng.lat(), lng: e.latLng.lng() },
                                    });
                                }}
                                options={{
                                    disableDefaultUI: true,
                                    clickableIcons: false,
                                    disableDoubleClickZoom: true,
                                    gestureHandling: "greedy",
                                }}
                            >
                                {/* เช็คว่ามีค่า currentPath ใน state หรือยัง ถ้ามีให้แสดง Marker */}
                                {currentPath && <Marker position={currentPath} />}
                            </GoogleMap>
                        </LoadScript>
                    </div>
                </Modal.Body>
                <Modal.Footer className="py-2 border-0 d-flex justify-content-between">
                    <div className="d-flex flex-wrap">
                        <span className="me-2">Latitude: {currentPath?.lat || "-"},</span>
                        <span>Longitude: {currentPath?.lng || "-"}</span>
                    </div>
                    <div className="d-flex">
                        <button
                            className="btn btn-success px-5 me-1"
                            onClick={() => {
                                if (!currentPath) return alert("", "warning", t("warning"), t("validate_map_position_required"));
                                this.setState({ modal_map: false, modal_update: true, modal_create: true, latitude: currentPath.lat.toString(), longitude: currentPath.lng.toString() });
                            }}
                        >
                            {t("save")}
                        </button>
                        <button
                            className="btn btn-outline-success px-5 ms-1"
                            onClick={() => {
                                this.setState({ modal_map: false, modal_update: false, modal_create: false });
                            }}
                        >
                            {t("cancel")}
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    );
  }
}
